import { gql } from '@apollo/client';

export const UPDATE_PROJECT_THANK_YOU_REDIRECT_LINK = gql`
  mutation UpdateProjectThankYouLink($id: ID!, $redirectLink: String!, $hasMrId: Boolean!) {
    updateProjectThankYouLink(id: $id, redirectLink: $redirectLink, hasMrId: $hasMrId) {
      project {
        id
        thankYouRedirectLink
        hasMrId
      }
    }
  }
`;

export const UPDATE_PROJECT_DISQUALIFY_REDIRECT_LINK = gql`
  mutation updateProjectDisqualifyRedirectUrl($id: ID!, $redirectUrl: String!, $hasMrId: Boolean!) {
    updateProjectDisqualifyRedirectUrl(id: $id, redirectUrl: $redirectUrl, hasMrId: $hasMrId) {
      project {
        id
        disqualifyRedirectUrl
        hasMrId
      }
    }
  }
`;
